import { useState as B0, useLayoutEffect as j0, useMemo as K0 } from "react";
const G0 = [
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "S",
  "B",
  "S",
  "WS",
  "B",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "B",
  "B",
  "B",
  "S",
  "WS",
  "ON",
  "ON",
  "ET",
  "ET",
  "ET",
  "ON",
  "ON",
  "ON",
  "ON",
  "ON",
  "ES",
  "CS",
  "ES",
  "CS",
  "CS",
  "EN",
  "EN",
  "EN",
  "EN",
  "EN",
  "EN",
  "EN",
  "EN",
  "EN",
  "EN",
  "CS",
  "ON",
  "ON",
  "ON",
  "ON",
  "ON",
  "ON",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "ON",
  "ON",
  "ON",
  "ON",
  "ON",
  "ON",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "ON",
  "ON",
  "ON",
  "ON",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "B",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "BN",
  "CS",
  "ON",
  "ET",
  "ET",
  "ET",
  "ET",
  "ON",
  "ON",
  "ON",
  "ON",
  "L",
  "ON",
  "ON",
  "BN",
  "ON",
  "ON",
  "ET",
  "ET",
  "EN",
  "EN",
  "ON",
  "L",
  "ON",
  "ON",
  "ON",
  "EN",
  "L",
  "ON",
  "ON",
  "ON",
  "ON",
  "ON",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "ON",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "ON",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L",
  "L"
], C0 = [
  [697, 698, "ON"],
  [706, 719, "ON"],
  [722, 735, "ON"],
  [741, 749, "ON"],
  [751, 767, "ON"],
  [768, 879, "NSM"],
  [884, 885, "ON"],
  [894, 894, "ON"],
  [900, 901, "ON"],
  [903, 903, "ON"],
  [1014, 1014, "ON"],
  [1155, 1161, "NSM"],
  [1418, 1418, "ON"],
  [1421, 1422, "ON"],
  [1423, 1423, "ET"],
  [1424, 1424, "R"],
  [1425, 1469, "NSM"],
  [1470, 1470, "R"],
  [1471, 1471, "NSM"],
  [1472, 1472, "R"],
  [1473, 1474, "NSM"],
  [1475, 1475, "R"],
  [1476, 1477, "NSM"],
  [1478, 1478, "R"],
  [1479, 1479, "NSM"],
  [1480, 1535, "R"],
  [1536, 1541, "AN"],
  [1542, 1543, "ON"],
  [1544, 1544, "AL"],
  [1545, 1546, "ET"],
  [1547, 1547, "AL"],
  [1548, 1548, "CS"],
  [1549, 1549, "AL"],
  [1550, 1551, "ON"],
  [1552, 1562, "NSM"],
  [1563, 1610, "AL"],
  [1611, 1631, "NSM"],
  [1632, 1641, "AN"],
  [1642, 1642, "ET"],
  [1643, 1644, "AN"],
  [1645, 1647, "AL"],
  [1648, 1648, "NSM"],
  [1649, 1749, "AL"],
  [1750, 1756, "NSM"],
  [1757, 1757, "AN"],
  [1758, 1758, "ON"],
  [1759, 1764, "NSM"],
  [1765, 1766, "AL"],
  [1767, 1768, "NSM"],
  [1769, 1769, "ON"],
  [1770, 1773, "NSM"],
  [1774, 1775, "AL"],
  [1776, 1785, "EN"],
  [1786, 1808, "AL"],
  [1809, 1809, "NSM"],
  [1810, 1839, "AL"],
  [1840, 1866, "NSM"],
  [1867, 1957, "AL"],
  [1958, 1968, "NSM"],
  [1969, 1983, "AL"],
  [1984, 2026, "R"],
  [2027, 2035, "NSM"],
  [2036, 2037, "R"],
  [2038, 2041, "ON"],
  [2042, 2044, "R"],
  [2045, 2045, "NSM"],
  [2046, 2069, "R"],
  [2070, 2073, "NSM"],
  [2074, 2074, "R"],
  [2075, 2083, "NSM"],
  [2084, 2084, "R"],
  [2085, 2087, "NSM"],
  [2088, 2088, "R"],
  [2089, 2093, "NSM"],
  [2094, 2136, "R"],
  [2137, 2139, "NSM"],
  [2140, 2143, "R"],
  [2144, 2191, "AL"],
  [2192, 2193, "AN"],
  [2194, 2198, "AL"],
  [2199, 2207, "NSM"],
  [2208, 2249, "AL"],
  [2250, 2273, "NSM"],
  [2274, 2274, "AN"],
  [2275, 2306, "NSM"],
  [2362, 2362, "NSM"],
  [2364, 2364, "NSM"],
  [2369, 2376, "NSM"],
  [2381, 2381, "NSM"],
  [2385, 2391, "NSM"],
  [2402, 2403, "NSM"],
  [2433, 2433, "NSM"],
  [2492, 2492, "NSM"],
  [2497, 2500, "NSM"],
  [2509, 2509, "NSM"],
  [2530, 2531, "NSM"],
  [2546, 2547, "ET"],
  [2555, 2555, "ET"],
  [2558, 2558, "NSM"],
  [2561, 2562, "NSM"],
  [2620, 2620, "NSM"],
  [2625, 2626, "NSM"],
  [2631, 2632, "NSM"],
  [2635, 2637, "NSM"],
  [2641, 2641, "NSM"],
  [2672, 2673, "NSM"],
  [2677, 2677, "NSM"],
  [2689, 2690, "NSM"],
  [2748, 2748, "NSM"],
  [2753, 2757, "NSM"],
  [2759, 2760, "NSM"],
  [2765, 2765, "NSM"],
  [2786, 2787, "NSM"],
  [2801, 2801, "ET"],
  [2810, 2815, "NSM"],
  [2817, 2817, "NSM"],
  [2876, 2876, "NSM"],
  [2879, 2879, "NSM"],
  [2881, 2884, "NSM"],
  [2893, 2893, "NSM"],
  [2901, 2902, "NSM"],
  [2914, 2915, "NSM"],
  [2946, 2946, "NSM"],
  [3008, 3008, "NSM"],
  [3021, 3021, "NSM"],
  [3059, 3064, "ON"],
  [3065, 3065, "ET"],
  [3066, 3066, "ON"],
  [3072, 3072, "NSM"],
  [3076, 3076, "NSM"],
  [3132, 3132, "NSM"],
  [3134, 3136, "NSM"],
  [3142, 3144, "NSM"],
  [3146, 3149, "NSM"],
  [3157, 3158, "NSM"],
  [3170, 3171, "NSM"],
  [3192, 3198, "ON"],
  [3201, 3201, "NSM"],
  [3260, 3260, "NSM"],
  [3276, 3277, "NSM"],
  [3298, 3299, "NSM"],
  [3328, 3329, "NSM"],
  [3387, 3388, "NSM"],
  [3393, 3396, "NSM"],
  [3405, 3405, "NSM"],
  [3426, 3427, "NSM"],
  [3457, 3457, "NSM"],
  [3530, 3530, "NSM"],
  [3538, 3540, "NSM"],
  [3542, 3542, "NSM"],
  [3633, 3633, "NSM"],
  [3636, 3642, "NSM"],
  [3647, 3647, "ET"],
  [3655, 3662, "NSM"],
  [3761, 3761, "NSM"],
  [3764, 3772, "NSM"],
  [3784, 3790, "NSM"],
  [3864, 3865, "NSM"],
  [3893, 3893, "NSM"],
  [3895, 3895, "NSM"],
  [3897, 3897, "NSM"],
  [3898, 3901, "ON"],
  [3953, 3966, "NSM"],
  [3968, 3972, "NSM"],
  [3974, 3975, "NSM"],
  [3981, 3991, "NSM"],
  [3993, 4028, "NSM"],
  [4038, 4038, "NSM"],
  [4141, 4144, "NSM"],
  [4146, 4151, "NSM"],
  [4153, 4154, "NSM"],
  [4157, 4158, "NSM"],
  [4184, 4185, "NSM"],
  [4190, 4192, "NSM"],
  [4209, 4212, "NSM"],
  [4226, 4226, "NSM"],
  [4229, 4230, "NSM"],
  [4237, 4237, "NSM"],
  [4253, 4253, "NSM"],
  [4957, 4959, "NSM"],
  [5008, 5017, "ON"],
  [5120, 5120, "ON"],
  [5760, 5760, "WS"],
  [5787, 5788, "ON"],
  [5906, 5908, "NSM"],
  [5938, 5939, "NSM"],
  [5970, 5971, "NSM"],
  [6002, 6003, "NSM"],
  [6068, 6069, "NSM"],
  [6071, 6077, "NSM"],
  [6086, 6086, "NSM"],
  [6089, 6099, "NSM"],
  [6107, 6107, "ET"],
  [6109, 6109, "NSM"],
  [6128, 6137, "ON"],
  [6144, 6154, "ON"],
  [6155, 6157, "NSM"],
  [6158, 6158, "BN"],
  [6159, 6159, "NSM"],
  [6277, 6278, "NSM"],
  [6313, 6313, "NSM"],
  [6432, 6434, "NSM"],
  [6439, 6440, "NSM"],
  [6450, 6450, "NSM"],
  [6457, 6459, "NSM"],
  [6464, 6464, "ON"],
  [6468, 6469, "ON"],
  [6622, 6655, "ON"],
  [6679, 6680, "NSM"],
  [6683, 6683, "NSM"],
  [6742, 6742, "NSM"],
  [6744, 6750, "NSM"],
  [6752, 6752, "NSM"],
  [6754, 6754, "NSM"],
  [6757, 6764, "NSM"],
  [6771, 6780, "NSM"],
  [6783, 6783, "NSM"],
  [6832, 6877, "NSM"],
  [6880, 6891, "NSM"],
  [6912, 6915, "NSM"],
  [6964, 6964, "NSM"],
  [6966, 6970, "NSM"],
  [6972, 6972, "NSM"],
  [6978, 6978, "NSM"],
  [7019, 7027, "NSM"],
  [7040, 7041, "NSM"],
  [7074, 7077, "NSM"],
  [7080, 7081, "NSM"],
  [7083, 7085, "NSM"],
  [7142, 7142, "NSM"],
  [7144, 7145, "NSM"],
  [7149, 7149, "NSM"],
  [7151, 7153, "NSM"],
  [7212, 7219, "NSM"],
  [7222, 7223, "NSM"],
  [7376, 7378, "NSM"],
  [7380, 7392, "NSM"],
  [7394, 7400, "NSM"],
  [7405, 7405, "NSM"],
  [7412, 7412, "NSM"],
  [7416, 7417, "NSM"],
  [7616, 7679, "NSM"],
  [8125, 8125, "ON"],
  [8127, 8129, "ON"],
  [8141, 8143, "ON"],
  [8157, 8159, "ON"],
  [8173, 8175, "ON"],
  [8189, 8190, "ON"],
  [8192, 8202, "WS"],
  [8203, 8205, "BN"],
  [8207, 8207, "R"],
  [8208, 8231, "ON"],
  [8232, 8232, "WS"],
  [8233, 8233, "B"],
  [8234, 8238, "BN"],
  [8239, 8239, "CS"],
  [8240, 8244, "ET"],
  [8245, 8259, "ON"],
  [8260, 8260, "CS"],
  [8261, 8286, "ON"],
  [8287, 8287, "WS"],
  [8288, 8303, "BN"],
  [8304, 8304, "EN"],
  [8308, 8313, "EN"],
  [8314, 8315, "ES"],
  [8316, 8318, "ON"],
  [8320, 8329, "EN"],
  [8330, 8331, "ES"],
  [8332, 8334, "ON"],
  [8352, 8399, "ET"],
  [8400, 8432, "NSM"],
  [8448, 8449, "ON"],
  [8451, 8454, "ON"],
  [8456, 8457, "ON"],
  [8468, 8468, "ON"],
  [8470, 8472, "ON"],
  [8478, 8483, "ON"],
  [8485, 8485, "ON"],
  [8487, 8487, "ON"],
  [8489, 8489, "ON"],
  [8494, 8494, "ET"],
  [8506, 8507, "ON"],
  [8512, 8516, "ON"],
  [8522, 8525, "ON"],
  [8528, 8543, "ON"],
  [8585, 8587, "ON"],
  [8592, 8721, "ON"],
  [8722, 8722, "ES"],
  [8723, 8723, "ET"],
  [8724, 9013, "ON"],
  [9083, 9108, "ON"],
  [9110, 9257, "ON"],
  [9280, 9290, "ON"],
  [9312, 9351, "ON"],
  [9352, 9371, "EN"],
  [9450, 9899, "ON"],
  [9901, 10239, "ON"],
  [10496, 11123, "ON"],
  [11126, 11263, "ON"],
  [11493, 11498, "ON"],
  [11503, 11505, "NSM"],
  [11513, 11519, "ON"],
  [11647, 11647, "NSM"],
  [11744, 11775, "NSM"],
  [11776, 11869, "ON"],
  [11904, 11929, "ON"],
  [11931, 12019, "ON"],
  [12032, 12245, "ON"],
  [12272, 12287, "ON"],
  [12288, 12288, "WS"],
  [12289, 12292, "ON"],
  [12296, 12320, "ON"],
  [12330, 12333, "NSM"],
  [12336, 12336, "ON"],
  [12342, 12343, "ON"],
  [12349, 12351, "ON"],
  [12441, 12442, "NSM"],
  [12443, 12444, "ON"],
  [12448, 12448, "ON"],
  [12539, 12539, "ON"],
  [12736, 12773, "ON"],
  [12783, 12783, "ON"],
  [12829, 12830, "ON"],
  [12880, 12895, "ON"],
  [12924, 12926, "ON"],
  [12977, 12991, "ON"],
  [13004, 13007, "ON"],
  [13175, 13178, "ON"],
  [13278, 13279, "ON"],
  [13311, 13311, "ON"],
  [19904, 19967, "ON"],
  [42128, 42182, "ON"],
  [42509, 42511, "ON"],
  [42607, 42610, "NSM"],
  [42611, 42611, "ON"],
  [42612, 42621, "NSM"],
  [42622, 42623, "ON"],
  [42654, 42655, "NSM"],
  [42736, 42737, "NSM"],
  [42752, 42785, "ON"],
  [42888, 42888, "ON"],
  [43010, 43010, "NSM"],
  [43014, 43014, "NSM"],
  [43019, 43019, "NSM"],
  [43045, 43046, "NSM"],
  [43048, 43051, "ON"],
  [43052, 43052, "NSM"],
  [43064, 43065, "ET"],
  [43124, 43127, "ON"],
  [43204, 43205, "NSM"],
  [43232, 43249, "NSM"],
  [43263, 43263, "NSM"],
  [43302, 43309, "NSM"],
  [43335, 43345, "NSM"],
  [43392, 43394, "NSM"],
  [43443, 43443, "NSM"],
  [43446, 43449, "NSM"],
  [43452, 43453, "NSM"],
  [43493, 43493, "NSM"],
  [43561, 43566, "NSM"],
  [43569, 43570, "NSM"],
  [43573, 43574, "NSM"],
  [43587, 43587, "NSM"],
  [43596, 43596, "NSM"],
  [43644, 43644, "NSM"],
  [43696, 43696, "NSM"],
  [43698, 43700, "NSM"],
  [43703, 43704, "NSM"],
  [43710, 43711, "NSM"],
  [43713, 43713, "NSM"],
  [43756, 43757, "NSM"],
  [43766, 43766, "NSM"],
  [43882, 43883, "ON"],
  [44005, 44005, "NSM"],
  [44008, 44008, "NSM"],
  [44013, 44013, "NSM"],
  [64285, 64285, "R"],
  [64286, 64286, "NSM"],
  [64287, 64296, "R"],
  [64297, 64297, "ES"],
  [64298, 64335, "R"],
  [64336, 64450, "AL"],
  [64451, 64466, "ON"],
  [64467, 64829, "AL"],
  [64830, 64847, "ON"],
  [64848, 64911, "AL"],
  [64912, 64913, "ON"],
  [64914, 64967, "AL"],
  [64968, 64975, "ON"],
  [64976, 65007, "BN"],
  [65008, 65020, "AL"],
  [65021, 65023, "ON"],
  [65024, 65039, "NSM"],
  [65040, 65049, "ON"],
  [65056, 65071, "NSM"],
  [65072, 65103, "ON"],
  [65104, 65104, "CS"],
  [65105, 65105, "ON"],
  [65106, 65106, "CS"],
  [65108, 65108, "ON"],
  [65109, 65109, "CS"],
  [65110, 65118, "ON"],
  [65119, 65119, "ET"],
  [65120, 65121, "ON"],
  [65122, 65123, "ES"],
  [65124, 65126, "ON"],
  [65128, 65128, "ON"],
  [65129, 65130, "ET"],
  [65131, 65131, "ON"],
  [65136, 65278, "AL"],
  [65279, 65279, "BN"],
  [65281, 65282, "ON"],
  [65283, 65285, "ET"],
  [65286, 65290, "ON"],
  [65291, 65291, "ES"],
  [65292, 65292, "CS"],
  [65293, 65293, "ES"],
  [65294, 65295, "CS"],
  [65296, 65305, "EN"],
  [65306, 65306, "CS"],
  [65307, 65312, "ON"],
  [65339, 65344, "ON"],
  [65371, 65381, "ON"],
  [65504, 65505, "ET"],
  [65506, 65508, "ON"],
  [65509, 65510, "ET"],
  [65512, 65518, "ON"],
  [65520, 65528, "BN"],
  [65529, 65533, "ON"],
  [65534, 65535, "BN"],
  [65793, 65793, "ON"],
  [65856, 65932, "ON"],
  [65936, 65948, "ON"],
  [65952, 65952, "ON"],
  [66045, 66045, "NSM"],
  [66272, 66272, "NSM"],
  [66273, 66299, "EN"],
  [66422, 66426, "NSM"],
  [67584, 67870, "R"],
  [67871, 67871, "ON"],
  [67872, 68096, "R"],
  [68097, 68099, "NSM"],
  [68100, 68100, "R"],
  [68101, 68102, "NSM"],
  [68103, 68107, "R"],
  [68108, 68111, "NSM"],
  [68112, 68151, "R"],
  [68152, 68154, "NSM"],
  [68155, 68158, "R"],
  [68159, 68159, "NSM"],
  [68160, 68324, "R"],
  [68325, 68326, "NSM"],
  [68327, 68408, "R"],
  [68409, 68415, "ON"],
  [68416, 68863, "R"],
  [68864, 68899, "AL"],
  [68900, 68903, "NSM"],
  [68904, 68911, "AL"],
  [68912, 68921, "AN"],
  [68922, 68927, "AL"],
  [68928, 68937, "AN"],
  [68938, 68968, "R"],
  [68969, 68973, "NSM"],
  [68974, 68974, "ON"],
  [68975, 69215, "R"],
  [69216, 69246, "AN"],
  [69247, 69290, "R"],
  [69291, 69292, "NSM"],
  [69293, 69311, "R"],
  [69312, 69327, "AL"],
  [69328, 69336, "ON"],
  [69337, 69369, "AL"],
  [69370, 69375, "NSM"],
  [69376, 69423, "R"],
  [69424, 69445, "AL"],
  [69446, 69456, "NSM"],
  [69457, 69487, "AL"],
  [69488, 69505, "R"],
  [69506, 69509, "NSM"],
  [69510, 69631, "R"],
  [69633, 69633, "NSM"],
  [69688, 69702, "NSM"],
  [69714, 69733, "ON"],
  [69744, 69744, "NSM"],
  [69747, 69748, "NSM"],
  [69759, 69761, "NSM"],
  [69811, 69814, "NSM"],
  [69817, 69818, "NSM"],
  [69826, 69826, "NSM"],
  [69888, 69890, "NSM"],
  [69927, 69931, "NSM"],
  [69933, 69940, "NSM"],
  [70003, 70003, "NSM"],
  [70016, 70017, "NSM"],
  [70070, 70078, "NSM"],
  [70089, 70092, "NSM"],
  [70095, 70095, "NSM"],
  [70191, 70193, "NSM"],
  [70196, 70196, "NSM"],
  [70198, 70199, "NSM"],
  [70206, 70206, "NSM"],
  [70209, 70209, "NSM"],
  [70367, 70367, "NSM"],
  [70371, 70378, "NSM"],
  [70400, 70401, "NSM"],
  [70459, 70460, "NSM"],
  [70464, 70464, "NSM"],
  [70502, 70508, "NSM"],
  [70512, 70516, "NSM"],
  [70587, 70592, "NSM"],
  [70606, 70606, "NSM"],
  [70608, 70608, "NSM"],
  [70610, 70610, "NSM"],
  [70625, 70626, "NSM"],
  [70712, 70719, "NSM"],
  [70722, 70724, "NSM"],
  [70726, 70726, "NSM"],
  [70750, 70750, "NSM"],
  [70835, 70840, "NSM"],
  [70842, 70842, "NSM"],
  [70847, 70848, "NSM"],
  [70850, 70851, "NSM"],
  [71090, 71093, "NSM"],
  [71100, 71101, "NSM"],
  [71103, 71104, "NSM"],
  [71132, 71133, "NSM"],
  [71219, 71226, "NSM"],
  [71229, 71229, "NSM"],
  [71231, 71232, "NSM"],
  [71264, 71276, "ON"],
  [71339, 71339, "NSM"],
  [71341, 71341, "NSM"],
  [71344, 71349, "NSM"],
  [71351, 71351, "NSM"],
  [71453, 71453, "NSM"],
  [71455, 71455, "NSM"],
  [71458, 71461, "NSM"],
  [71463, 71467, "NSM"],
  [71727, 71735, "NSM"],
  [71737, 71738, "NSM"],
  [71995, 71996, "NSM"],
  [71998, 71998, "NSM"],
  [72003, 72003, "NSM"],
  [72148, 72151, "NSM"],
  [72154, 72155, "NSM"],
  [72160, 72160, "NSM"],
  [72193, 72198, "NSM"],
  [72201, 72202, "NSM"],
  [72243, 72248, "NSM"],
  [72251, 72254, "NSM"],
  [72263, 72263, "NSM"],
  [72273, 72278, "NSM"],
  [72281, 72283, "NSM"],
  [72330, 72342, "NSM"],
  [72344, 72345, "NSM"],
  [72544, 72544, "NSM"],
  [72546, 72548, "NSM"],
  [72550, 72550, "NSM"],
  [72752, 72758, "NSM"],
  [72760, 72765, "NSM"],
  [72850, 72871, "NSM"],
  [72874, 72880, "NSM"],
  [72882, 72883, "NSM"],
  [72885, 72886, "NSM"],
  [73009, 73014, "NSM"],
  [73018, 73018, "NSM"],
  [73020, 73021, "NSM"],
  [73023, 73029, "NSM"],
  [73031, 73031, "NSM"],
  [73104, 73105, "NSM"],
  [73109, 73109, "NSM"],
  [73111, 73111, "NSM"],
  [73459, 73460, "NSM"],
  [73472, 73473, "NSM"],
  [73526, 73530, "NSM"],
  [73536, 73536, "NSM"],
  [73538, 73538, "NSM"],
  [73562, 73562, "NSM"],
  [73685, 73692, "ON"],
  [73693, 73696, "ET"],
  [73697, 73713, "ON"],
  [78912, 78912, "NSM"],
  [78919, 78933, "NSM"],
  [90398, 90409, "NSM"],
  [90413, 90415, "NSM"],
  [92912, 92916, "NSM"],
  [92976, 92982, "NSM"],
  [94031, 94031, "NSM"],
  [94095, 94098, "NSM"],
  [94178, 94178, "ON"],
  [94180, 94180, "NSM"],
  [113821, 113822, "NSM"],
  [113824, 113827, "BN"],
  [117760, 117973, "ON"],
  [118e3, 118009, "EN"],
  [118010, 118012, "ON"],
  [118016, 118451, "ON"],
  [118458, 118480, "ON"],
  [118496, 118512, "ON"],
  [118528, 118573, "NSM"],
  [118576, 118598, "NSM"],
  [119143, 119145, "NSM"],
  [119155, 119162, "BN"],
  [119163, 119170, "NSM"],
  [119173, 119179, "NSM"],
  [119210, 119213, "NSM"],
  [119273, 119274, "ON"],
  [119296, 119361, "ON"],
  [119362, 119364, "NSM"],
  [119365, 119365, "ON"],
  [119552, 119638, "ON"],
  [120513, 120513, "ON"],
  [120539, 120539, "ON"],
  [120571, 120571, "ON"],
  [120597, 120597, "ON"],
  [120629, 120629, "ON"],
  [120655, 120655, "ON"],
  [120687, 120687, "ON"],
  [120713, 120713, "ON"],
  [120745, 120745, "ON"],
  [120771, 120771, "ON"],
  [120782, 120831, "EN"],
  [121344, 121398, "NSM"],
  [121403, 121452, "NSM"],
  [121461, 121461, "NSM"],
  [121476, 121476, "NSM"],
  [121499, 121503, "NSM"],
  [121505, 121519, "NSM"],
  [122880, 122886, "NSM"],
  [122888, 122904, "NSM"],
  [122907, 122913, "NSM"],
  [122915, 122916, "NSM"],
  [122918, 122922, "NSM"],
  [123023, 123023, "NSM"],
  [123184, 123190, "NSM"],
  [123566, 123566, "NSM"],
  [123628, 123631, "NSM"],
  [123647, 123647, "ET"],
  [124140, 124143, "NSM"],
  [124398, 124399, "NSM"],
  [124643, 124643, "NSM"],
  [124646, 124646, "NSM"],
  [124654, 124655, "NSM"],
  [124661, 124661, "NSM"],
  [124928, 125135, "R"],
  [125136, 125142, "NSM"],
  [125143, 125251, "R"],
  [125252, 125258, "NSM"],
  [125259, 126063, "R"],
  [126064, 126143, "AL"],
  [126144, 126207, "R"],
  [126208, 126287, "AL"],
  [126288, 126463, "R"],
  [126464, 126703, "AL"],
  [126704, 126705, "ON"],
  [126706, 126719, "AL"],
  [126720, 126975, "R"],
  [126976, 127019, "ON"],
  [127024, 127123, "ON"],
  [127136, 127150, "ON"],
  [127153, 127167, "ON"],
  [127169, 127183, "ON"],
  [127185, 127221, "ON"],
  [127232, 127242, "EN"],
  [127243, 127247, "ON"],
  [127279, 127279, "ON"],
  [127338, 127343, "ON"],
  [127405, 127405, "ON"],
  [127584, 127589, "ON"],
  [127744, 128728, "ON"],
  [128732, 128748, "ON"],
  [128752, 128764, "ON"],
  [128768, 128985, "ON"],
  [128992, 129003, "ON"],
  [129008, 129008, "ON"],
  [129024, 129035, "ON"],
  [129040, 129095, "ON"],
  [129104, 129113, "ON"],
  [129120, 129159, "ON"],
  [129168, 129197, "ON"],
  [129200, 129211, "ON"],
  [129216, 129217, "ON"],
  [129232, 129240, "ON"],
  [129280, 129623, "ON"],
  [129632, 129645, "ON"],
  [129648, 129660, "ON"],
  [129664, 129674, "ON"],
  [129678, 129734, "ON"],
  [129736, 129736, "ON"],
  [129741, 129756, "ON"],
  [129759, 129770, "ON"],
  [129775, 129784, "ON"],
  [129792, 129938, "ON"],
  [129940, 130031, "ON"],
  [130032, 130041, "EN"],
  [130042, 130042, "ON"],
  [131070, 131071, "BN"],
  [196606, 196607, "BN"],
  [262142, 262143, "BN"],
  [327678, 327679, "BN"],
  [393214, 393215, "BN"],
  [458750, 458751, "BN"],
  [524286, 524287, "BN"],
  [589822, 589823, "BN"],
  [655358, 655359, "BN"],
  [720894, 720895, "BN"],
  [786430, 786431, "BN"],
  [851966, 851967, "BN"],
  [917502, 917759, "BN"],
  [917760, 917999, "NSM"],
  [918e3, 921599, "BN"],
  [983038, 983039, "BN"],
  [1048574, 1048575, "BN"],
  [1114110, 1114111, "BN"]
];
function z0(e) {
  if (e <= 255)
    return G0[e];
  let t = 0, n = C0.length - 1;
  for (; t <= n; ) {
    const r = t + n >> 1, i = C0[r];
    if (e < i[0]) {
      n = r - 1;
      continue;
    }
    if (e > i[1]) {
      t = r + 1;
      continue;
    }
    return i[2];
  }
  return "L";
}
function J0(e) {
  const t = e.length;
  if (t === 0)
    return null;
  const n = new Array(t);
  let r = !1;
  for (let s = 0; s < t; ) {
    const u = e.charCodeAt(s);
    let c = u, N = 1;
    if (u >= 55296 && u <= 56319 && s + 1 < t) {
      const C = e.charCodeAt(s + 1);
      C >= 56320 && C <= 57343 && (c = (u - 55296 << 10) + (C - 56320) + 65536, N = 2);
    }
    const f = z0(c);
    (f === "R" || f === "AL" || f === "AN") && (r = !0);
    for (let C = 0; C < N; C++)
      n[s + C] = f;
    s += N;
  }
  if (!r)
    return null;
  let i = 0;
  for (let s = 0; s < t; s++) {
    const u = n[s];
    if (u === "L") {
      i = 0;
      break;
    }
    if (u === "R" || u === "AL") {
      i = 1;
      break;
    }
  }
  const x = new Int8Array(t);
  for (let s = 0; s < t; s++)
    x[s] = i;
  const F = i & 1 ? "R" : "L", l = F;
  let o = l;
  for (let s = 0; s < t; s++)
    n[s] === "NSM" ? n[s] = o : o = n[s];
  o = l;
  for (let s = 0; s < t; s++) {
    const u = n[s];
    u === "EN" ? n[s] = o === "AL" ? "AN" : "EN" : (u === "R" || u === "L" || u === "AL") && (o = u);
  }
  for (let s = 0; s < t; s++)
    n[s] === "AL" && (n[s] = "R");
  for (let s = 1; s < t - 1; s++)
    n[s] === "ES" && n[s - 1] === "EN" && n[s + 1] === "EN" && (n[s] = "EN"), n[s] === "CS" && (n[s - 1] === "EN" || n[s - 1] === "AN") && n[s + 1] === n[s - 1] && (n[s] = n[s - 1]);
  for (let s = 0; s < t; s++) {
    if (n[s] !== "EN")
      continue;
    let u;
    for (u = s - 1; u >= 0 && n[u] === "ET"; u--)
      n[u] = "EN";
    for (u = s + 1; u < t && n[u] === "ET"; u++)
      n[u] = "EN";
  }
  for (let s = 0; s < t; s++) {
    const u = n[s];
    (u === "WS" || u === "ES" || u === "ET" || u === "CS") && (n[s] = "ON");
  }
  o = l;
  for (let s = 0; s < t; s++) {
    const u = n[s];
    u === "EN" ? n[s] = o === "L" ? "L" : "EN" : (u === "R" || u === "L") && (o = u);
  }
  for (let s = 0; s < t; s++) {
    if (n[s] !== "ON")
      continue;
    let u = s + 1;
    for (; u < t && n[u] === "ON"; )
      u++;
    const c = s > 0 ? n[s - 1] : l, N = u < t ? n[u] : l, f = c !== "L" ? "R" : "L";
    if (f === (N !== "L" ? "R" : "L"))
      for (let p = s; p < u; p++)
        n[p] = f;
    s = u - 1;
  }
  for (let s = 0; s < t; s++)
    n[s] === "ON" && (n[s] = F);
  for (let s = 0; s < t; s++) {
    const u = n[s];
    (x[s] & 1) === 0 ? u === "R" ? x[s]++ : (u === "AN" || u === "EN") && (x[s] += 2) : (u === "L" || u === "AN" || u === "EN") && x[s]++;
  }
  return x;
}
function U0(e, t) {
  const n = J0(e);
  if (n === null)
    return null;
  const r = new Int8Array(t.length);
  for (let i = 0; i < t.length; i++)
    r[i] = n[t[i]];
  return r;
}
const H0 = /[ \t\n\r\f]+/g, Q0 = /[\t\n\r\f]| {2,}|^ | $/;
function $0(e) {
  const t = e ?? "normal";
  return t === "pre-wrap" ? { mode: t, preserveOrdinarySpaces: !0, preserveHardBreaks: !0 } : { mode: t, preserveOrdinarySpaces: !1, preserveHardBreaks: !1 };
}
function _0(e) {
  if (!Q0.test(e))
    return e;
  let t = e.replace(H0, " ");
  return t.charCodeAt(0) === 32 && (t = t.slice(1)), t.length > 0 && t.charCodeAt(t.length - 1) === 32 && (t = t.slice(0, -1)), t;
}
function q0(e) {
  return /[\r\f]/.test(e) ? e.replace(/\r\n/g, `
`).replace(/[\r\f]/g, `
`) : e;
}
let i0 = null, X0;
function Z0() {
  return i0 === null && (i0 = new Intl.Segmenter(X0, { granularity: "word" })), i0;
}
const V0 = new RegExp("\\p{Script=Arabic}", "u"), U = new RegExp("\\p{M}", "u"), c0 = new RegExp("\\p{Nd}", "u");
function d0(e) {
  return V0.test(e);
}
function M0(e) {
  return e >= 19968 && e <= 40959 || e >= 13312 && e <= 19903 || e >= 131072 && e <= 173791 || e >= 173824 && e <= 177983 || e >= 177984 && e <= 178207 || e >= 178208 && e <= 183983 || e >= 183984 && e <= 191471 || e >= 191472 && e <= 192093 || e >= 194560 && e <= 195103 || e >= 196608 && e <= 201551 || e >= 201552 && e <= 205743 || e >= 205744 && e <= 210041 || e >= 63744 && e <= 64255 || e >= 12288 && e <= 12351 || e >= 12352 && e <= 12447 || e >= 12448 && e <= 12543 || e >= 12592 && e <= 12687 || e >= 44032 && e <= 55215 || e >= 65280 && e <= 65519;
}
function G(e) {
  for (let t = 0; t < e.length; t++) {
    const n = e.charCodeAt(t);
    if (!(n < 12288)) {
      if (n >= 55296 && n <= 56319 && t + 1 < e.length) {
        const r = e.charCodeAt(t + 1);
        if (r >= 56320 && r <= 57343) {
          const i = (n - 55296 << 10) + (r - 56320) + 65536;
          if (M0(i))
            return !0;
          t++;
          continue;
        }
      }
      if (M0(n))
        return !0;
    }
  }
  return !1;
}
function Y0(e) {
  const t = q(e);
  return t !== null && (N0.has(t) || Q.has(t));
}
const ee = /* @__PURE__ */ new Set([
  " ",
  " ",
  "⁠",
  "\uFEFF"
]), te = /* @__PURE__ */ new Set([
  "-",
  "‐",
  "–",
  "—"
]);
function ne(e) {
  const t = q(e);
  return t !== null && ee.has(t);
}
function xe(e) {
  const t = q(e);
  return t !== null && te.has(t);
}
function w0(e, t) {
  return ne(e) ? !1 : t ? !(Y0(e) || xe(e)) : !0;
}
const N0 = /* @__PURE__ */ new Set([
  "，",
  "．",
  "！",
  "：",
  "；",
  "？",
  "、",
  "。",
  "・",
  "）",
  "〕",
  "〉",
  "》",
  "」",
  "』",
  "】",
  "〗",
  "〙",
  "〛",
  "ー",
  "々",
  "〻",
  "ゝ",
  "ゞ",
  "ヽ",
  "ヾ"
]), Y = /* @__PURE__ */ new Set([
  '"',
  "(",
  "[",
  "{",
  "¡",
  "¿",
  "“",
  "‘",
  "‚",
  "„",
  "«",
  "‹",
  "⸘",
  "（",
  "〔",
  "〈",
  "《",
  "「",
  "『",
  "【",
  "〖",
  "〘",
  "〚"
]), a0 = /* @__PURE__ */ new Set([
  "'",
  "’"
]), Q = /* @__PURE__ */ new Set([
  ".",
  ",",
  "!",
  "?",
  ":",
  ";",
  "،",
  "؛",
  "؟",
  "।",
  "॥",
  "၊",
  "။",
  "၌",
  "၍",
  "၏",
  ")",
  "]",
  "}",
  "%",
  '"',
  "”",
  "’",
  "»",
  "›",
  "…"
]), re = /* @__PURE__ */ new Set([
  ":",
  ".",
  "،",
  "؛"
]), ie = /* @__PURE__ */ new Set([
  "၏"
]), se = /* @__PURE__ */ new Set([
  "”",
  "’",
  "»",
  "›",
  "」",
  "』",
  "】",
  "》",
  "〉",
  "〕",
  "）"
]);
function ue(e) {
  if (f0(e))
    return !0;
  let t = !1;
  for (const n of e) {
    if (Q.has(n) || t0(n)) {
      t = !0;
      continue;
    }
    if (!(t && U.test(n)))
      return !1;
  }
  return t;
}
function Fe(e) {
  for (const t of e)
    if (!N0.has(t) && !Q.has(t))
      return !1;
  return e.length > 0;
}
function le(e) {
  if (f0(e))
    return !0;
  for (const t of e)
    if (!Y.has(t) && !a0.has(t) && !U.test(t) && !t0(t))
      return !1;
  return e.length > 0;
}
function f0(e) {
  let t = !1;
  for (const n of e)
    if (!(n === "\\" || U.test(n))) {
      if (Y.has(n) || Q.has(n) || a0.has(n)) {
        t = !0;
        continue;
      }
      return !1;
    }
  return t;
}
function e0(e, t) {
  const n = t - 1;
  if (n <= 0)
    return Math.max(n, 0);
  const r = e.charCodeAt(n);
  if (r < 56320 || r > 57343)
    return n;
  const i = n - 1;
  if (i < 0)
    return n;
  const x = e.charCodeAt(i);
  return x >= 55296 && x <= 56319 ? i : n;
}
function q(e) {
  if (e.length === 0)
    return null;
  const t = e0(e, e.length);
  return e.slice(t);
}
function oe(e) {
  for (const t of e)
    if (!U.test(t))
      return t;
  return null;
}
function ce(e) {
  for (let t = e.length; t > 0; ) {
    const n = e0(e, t), r = e.slice(n, t);
    if (!U.test(r))
      return r;
    t = n;
  }
  return null;
}
const Ne = [
  36,
  37,
  43,
  43,
  92,
  92,
  162,
  165,
  176,
  177,
  1423,
  1423,
  1545,
  1547,
  1642,
  1642,
  2046,
  2047,
  2546,
  2547,
  2553,
  2555,
  2801,
  2801,
  3065,
  3065,
  3449,
  3449,
  3647,
  3647,
  6107,
  6107,
  8240,
  8247,
  8279,
  8279,
  8352,
  8399,
  8451,
  8451,
  8457,
  8457,
  8470,
  8470,
  8722,
  8723,
  43064,
  43064,
  65020,
  65020,
  65129,
  65130,
  65284,
  65285,
  65504,
  65505,
  65509,
  65510,
  73693,
  73696,
  123647,
  123647,
  126124,
  126124,
  126128,
  126128
];
function ae(e, t) {
  for (let n = 0; n < t.length; n += 2)
    if (e >= t[n] && e <= t[n + 1])
      return !0;
  return !1;
}
function t0(e) {
  const t = e.codePointAt(0);
  return t !== void 0 && ae(t, Ne);
}
function fe(e) {
  const t = ce(e);
  return t !== null && t0(t);
}
function Se(e) {
  const t = oe(e);
  return t !== null && c0.test(t);
}
function Ae(e) {
  const t = Array.from(e);
  let n = t.length;
  for (; n > 0; ) {
    const r = t[n - 1];
    if (U.test(r)) {
      n--;
      continue;
    }
    if (Y.has(r) || a0.has(r)) {
      n--;
      continue;
    }
    break;
  }
  return n <= 0 || n === t.length ? null : {
    head: t.slice(0, n).join(""),
    tail: t.slice(n).join("")
  };
}
function Ee(e, t, n) {
  return n === "text" && !t && e.length === 1 && e !== "-" && e !== "—" ? e : null;
}
function D0(e, t, n, r) {
  const i = t[r], x = e[r];
  if (i == null)
    return x;
  const F = n[r];
  if (x.length === F)
    return x;
  const l = i.repeat(F);
  return e[r] = l, l;
}
function p0(e, t) {
  return e && t !== null && re.has(t);
}
function he(e) {
  const t = q(e);
  return t !== null && ie.has(t);
}
function Be(e) {
  if (e.length < 2 || e[0] !== " ")
    return null;
  const t = e.slice(1);
  return new RegExp("^\\p{M}+$", "u").test(t) ? { space: " ", marks: t } : null;
}
function F0(e) {
  let t = e.length;
  for (; t > 0; ) {
    const n = e0(e, t), r = e.slice(n, t);
    if (se.has(r))
      return !0;
    if (!Q.has(r))
      return !1;
    t = n;
  }
  return !1;
}
function Ce(e, t) {
  if (t.preserveOrdinarySpaces || t.preserveHardBreaks) {
    if (e === " ")
      return "preserved-space";
    if (e === "	")
      return "tab";
    if (t.preserveHardBreaks && e === `
`)
      return "hard-break";
  }
  return e === " " ? "space" : e === " " || e === " " || e === "⁠" || e === "\uFEFF" ? "glue" : e === "​" ? "zero-width-break" : e === "­" ? "soft-hyphen" : "text";
}
const de = /[\x20\t\n\xA0\xAD\u200B\u202F\u2060\uFEFF]/;
function K(e) {
  return e.length === 1 ? e[0] : e.join("");
}
function Me(e, t) {
  const n = [];
  for (let r = e.length - 1; r >= 0; r--)
    n.push(e[r]);
  return n.push(t), K(n);
}
function De(e, t, n, r) {
  if (!de.test(e))
    return [{ text: e, isWordLike: t, kind: "text", start: n }];
  const i = [];
  let x = null, F = [], l = n, o = !1, s = 0;
  for (const u of e) {
    const c = Ce(u, r), N = c === "text" && t;
    if (x !== null && c === x && N === o) {
      F.push(u), s += u.length;
      continue;
    }
    x !== null && i.push({
      text: K(F),
      isWordLike: o,
      kind: x,
      start: l
    }), x = c, F = [u], l = n + s, o = N, s += u.length;
  }
  return x !== null && i.push({
    text: K(F),
    isWordLike: o,
    kind: x,
    start: l
  }), i;
}
function l0(e) {
  return e === "space" || e === "preserved-space" || e === "zero-width-break" || e === "hard-break";
}
const pe = /^[A-Za-z][A-Za-z0-9+.-]*:$/;
function ge(e, t) {
  const n = e.texts[t];
  return n.startsWith("www.") ? !0 : pe.test(n) && t + 1 < e.len && e.kinds[t + 1] === "text" && e.texts[t + 1] === "//";
}
function Le(e) {
  return e.includes("?") && (e.includes("://") || e.startsWith("www."));
}
function Oe(e) {
  const t = e.texts.slice(), n = e.isWordLike.slice(), r = e.kinds.slice(), i = e.starts.slice();
  for (let F = 0; F < e.len; F++) {
    if (r[F] !== "text" || !ge(e, F))
      continue;
    const l = [t[F]];
    let o = F + 1;
    for (; o < e.len && !l0(r[o]); ) {
      l.push(t[o]), n[F] = !0;
      const s = t[o].includes("?");
      if (r[o] = "text", t[o] = "", o++, s)
        break;
    }
    t[F] = K(l);
  }
  let x = 0;
  for (let F = 0; F < t.length; F++) {
    const l = t[F];
    l.length !== 0 && (x !== F && (t[x] = l, n[x] = n[F], r[x] = r[F], i[x] = i[F]), x++);
  }
  return t.length = x, n.length = x, r.length = x, i.length = x, {
    len: x,
    texts: t,
    isWordLike: n,
    kinds: r,
    starts: i
  };
}
function ke(e) {
  const t = [], n = [], r = [], i = [];
  for (let x = 0; x < e.len; x++) {
    const F = e.texts[x];
    if (t.push(F), n.push(e.isWordLike[x]), r.push(e.kinds[x]), i.push(e.starts[x]), !Le(F))
      continue;
    const l = x + 1;
    if (l >= e.len || l0(e.kinds[l]))
      continue;
    const o = [], s = e.starts[l];
    let u = l;
    for (; u < e.len && !l0(e.kinds[u]); )
      o.push(e.texts[u]), u++;
    o.length > 0 && (t.push(K(o)), n.push(!0), r.push("text"), i.push(s), x = u - 1);
  }
  return {
    len: t.length,
    texts: t,
    isWordLike: n,
    kinds: r,
    starts: i
  };
}
const me = /* @__PURE__ */ new Set([
  ":",
  "-",
  "/",
  "×",
  ",",
  ".",
  "+",
  "–",
  "—"
]), be = /[\p{P}\p{S}\p{Co}]/u, We = new RegExp("\\p{Emoji_Presentation}", "u"), we = /* @__PURE__ */ new Set([
  "?",
  "֊",
  "-",
  "‐",
  "‒",
  "–",
  "—",
  "…",
  "‼",
  "‽",
  "⁉"
]);
function Re(e) {
  return e >= 33 && e <= 47 && e !== 45 || e >= 58 && e <= 64 && e !== 63 || e >= 91 && e <= 96 || e >= 123 && e <= 126;
}
function R0(e) {
  const t = e.charCodeAt(0);
  return t < 128 ? Re(t) : !we.has(e) && !We.test(e) && be.test(e);
}
function g0(e) {
  let t = !1;
  for (const n of e)
    if (!U.test(n)) {
      if (!R0(n))
        return !1;
      t = !0;
    }
  return t;
}
function ye(e) {
  for (let t = e.length; t > 0; ) {
    const n = e0(e, t), r = e.slice(n, t);
    if (U.test(r)) {
      t = n;
      continue;
    }
    return R0(r) || t0(r);
  }
  return !1;
}
function ve(e, t, n, r) {
  const i = !t && g0(e), x = !r && g0(n), F = fe(e), l = (t || F) && ye(e);
  return !i && !x && !l || G(e) || G(n) ? !1 : (t || i || F) && (r || x);
}
function y0(e) {
  for (const t of e)
    if (c0.test(t))
      return !0;
  return !1;
}
function Z(e) {
  if (e.length === 0)
    return !1;
  for (const t of e)
    if (!(c0.test(t) || me.has(t)))
      return !1;
  return !0;
}
function Te(e) {
  const t = [], n = [], r = [], i = [];
  for (let x = 0; x < e.len; x++) {
    const F = e.texts[x], l = e.kinds[x];
    if (l === "text" && Z(F) && y0(F)) {
      const o = [F];
      let s = x + 1;
      for (; s < e.len && e.kinds[s] === "text" && Z(e.texts[s]); )
        o.push(e.texts[s]), s++;
      t.push(K(o)), n.push(!0), r.push("text"), i.push(e.starts[x]), x = s - 1;
      continue;
    }
    t.push(F), n.push(e.isWordLike[x]), r.push(l), i.push(e.starts[x]);
  }
  return {
    len: t.length,
    texts: t,
    isWordLike: n,
    kinds: r,
    starts: i
  };
}
function Pe(e) {
  const t = [], n = [], r = [], i = [];
  let x = 0;
  for (; x < e.len; ) {
    const F = e.texts[x], l = e.kinds[x], o = e.isWordLike[x];
    if (l === "text") {
      const s = [F];
      let u = x + 1, c = o;
      for (; u < e.len && e.kinds[u] === "text" && ve(e.texts[u - 1], e.isWordLike[u - 1], e.texts[u], e.isWordLike[u]); ) {
        const N = e.texts[u];
        s.push(N), c = c || e.isWordLike[u], u++;
      }
      if (u > x + 1) {
        t.push(K(s)), n.push(c), r.push("text"), i.push(e.starts[x]), x = u;
        continue;
      }
    }
    t.push(F), n.push(o), r.push(l), i.push(e.starts[x]), x++;
  }
  return {
    len: t.length,
    texts: t,
    isWordLike: n,
    kinds: r,
    starts: i
  };
}
function Ie(e) {
  const t = [], n = [], r = [], i = [];
  for (let x = 0; x < e.len; x++) {
    const F = e.texts[x];
    if (e.kinds[x] === "text" && F.includes("-")) {
      const l = F.split("-");
      let o = l.length > 1;
      for (let s = 0; s < l.length; s++) {
        const u = l[s];
        if (!o)
          break;
        (u.length === 0 || !y0(u) || !Z(u)) && (o = !1);
      }
      if (o) {
        let s = 0;
        for (let u = 0; u < l.length; u++) {
          const c = l[u], N = u < l.length - 1 ? `${c}-` : c;
          t.push(N), n.push(!0), r.push("text"), i.push(e.starts[x] + s), s += N.length;
        }
        continue;
      }
    }
    t.push(F), n.push(e.isWordLike[x]), r.push(e.kinds[x]), i.push(e.starts[x]);
  }
  return {
    len: t.length,
    texts: t,
    isWordLike: n,
    kinds: r,
    starts: i
  };
}
function je(e) {
  const t = [], n = [], r = [], i = [];
  let x = 0;
  for (; x < e.len; ) {
    const F = [e.texts[x]];
    let l = e.isWordLike[x], o = e.kinds[x], s = e.starts[x];
    if (o === "glue") {
      const u = [F[0]], c = s;
      for (x++; x < e.len && e.kinds[x] === "glue"; )
        u.push(e.texts[x]), x++;
      const N = K(u);
      if (x < e.len && e.kinds[x] === "text")
        F[0] = N, F.push(e.texts[x]), l = e.isWordLike[x], o = "text", s = c, x++;
      else {
        t.push(N), n.push(!1), r.push("glue"), i.push(c);
        continue;
      }
    } else
      x++;
    if (o === "text")
      for (; x < e.len && e.kinds[x] === "glue"; ) {
        const u = [];
        for (; x < e.len && e.kinds[x] === "glue"; )
          u.push(e.texts[x]), x++;
        const c = K(u);
        if (x < e.len && e.kinds[x] === "text") {
          F.push(c, e.texts[x]), l = l || e.isWordLike[x], x++;
          continue;
        }
        F.push(c);
      }
    t.push(K(F)), n.push(l), r.push(o), i.push(s);
  }
  return {
    len: t.length,
    texts: t,
    isWordLike: n,
    kinds: r,
    starts: i
  };
}
function Ke(e) {
  const t = e.texts.slice(), n = e.isWordLike.slice(), r = e.kinds.slice(), i = e.starts.slice();
  for (let x = 0; x < t.length - 1; x++) {
    if (r[x] !== "text" || r[x + 1] !== "text" || !G(t[x]) || !G(t[x + 1]))
      continue;
    const F = Ae(t[x]);
    F !== null && (t[x] = F.head, t[x + 1] = F.tail + t[x + 1], i[x + 1] = i[x] + F.head.length);
  }
  return {
    len: t.length,
    texts: t,
    isWordLike: n,
    kinds: r,
    starts: i
  };
}
function Ge(e, t, n) {
  const r = Z0();
  let i = 0;
  const x = [], F = [], l = [], o = [], s = [], u = [], c = [], N = [], f = [], C = [], p = [], m = [];
  for (const a of r.segment(e))
    for (const E of De(a.segment, a.isWordLike ?? !1, a.index, n)) {
      let h = function() {
        u[A] !== null && (F[A] = [
          D0(x, u, c, A)
        ], u[A] = null), F[A].push(E.text), l[A] = l[A] || E.isWordLike, N[A] = N[A] || M, f[A] = f[A] || d, C[A] = R, p[A] = w, m[A] = p0(f[A], g);
      };
      const j = E.kind === "text", D = Ee(E.text, E.isWordLike, E.kind), M = G(E.text), d = d0(E.text), g = q(E.text), R = F0(E.text), w = he(E.text), A = i - 1;
      t.carryCJKAfterClosingQuote && j && i > 0 && o[A] === "text" && M && N[A] && C[A] || j && i > 0 && o[A] === "text" && Fe(E.text) && N[A] || j && i > 0 && o[A] === "text" && p[A] ? h() : j && i > 0 && o[A] === "text" && E.isWordLike && d && m[A] ? (h(), l[A] = !0) : D !== null && i > 0 && o[A] === "text" && u[A] === D ? c[A] = (c[A] ?? 1) + 1 : j && !E.isWordLike && i > 0 && o[A] === "text" && !N[A] && (ue(E.text) || E.text === "-" && l[A]) ? h() : (x[i] = E.text, F[i] = [E.text], l[i] = E.isWordLike, o[i] = E.kind, s[i] = E.start, u[i] = D, c[i] = D === null ? 0 : 1, N[i] = M, f[i] = d, C[i] = R, p[i] = w, m[i] = p0(d, g), i++);
    }
  for (let a = 0; a < i; a++) {
    if (u[a] !== null) {
      x[a] = D0(x, u, c, a);
      continue;
    }
    x[a] = K(F[a]);
  }
  for (let a = 1; a < i; a++)
    o[a] === "text" && !l[a] && f0(x[a]) && o[a - 1] === "text" && !N[a - 1] && (x[a - 1] += x[a], l[a - 1] = l[a - 1] || l[a], x[a] = "");
  const L = Array.from({ length: i }, () => null);
  let b = -1;
  for (let a = i - 1; a >= 0; a--) {
    const E = x[a];
    if (E.length !== 0) {
      if (o[a] === "text" && !l[a] && b >= 0 && o[b] === "text" && (le(E) || E === "-" && Se(x[b]))) {
        const j = L[b] ?? [];
        j.push(E), L[b] = j, s[b] = s[a], x[a] = "";
        continue;
      }
      b = a;
    }
  }
  for (let a = 0; a < i; a++) {
    const E = L[a];
    E != null && (x[a] = Me(E, x[a]));
  }
  let W = 0;
  for (let a = 0; a < i; a++) {
    const E = x[a];
    E.length !== 0 && (W !== a && (x[W] = E, l[W] = l[a], o[W] = o[a], s[W] = s[a]), W++);
  }
  x.length = W, l.length = W, o.length = W, s.length = W;
  const y = je({
    len: W,
    texts: x,
    isWordLike: l,
    kinds: o,
    starts: s
  }), k = Ke(Pe(Ie(Te(ke(Oe(y))))));
  for (let a = 0; a < k.len - 1; a++) {
    const E = Be(k.texts[a]);
    E !== null && (k.kinds[a] !== "space" && k.kinds[a] !== "preserved-space" || k.kinds[a + 1] !== "text" || !d0(k.texts[a + 1]) || (k.texts[a] = E.space, k.isWordLike[a] = !1, k.kinds[a] = k.kinds[a] === "preserved-space" ? "preserved-space" : "space", k.texts[a + 1] = E.marks + k.texts[a + 1], k.starts[a + 1] = k.starts[a] + E.space.length));
  }
  return k;
}
function ze(e, t) {
  if (e.len === 0)
    return [];
  if (!t.preserveHardBreaks)
    return [{
      startSegmentIndex: 0,
      endSegmentIndex: e.len,
      consumedEndSegmentIndex: e.len
    }];
  const n = [];
  let r = 0;
  for (let i = 0; i < e.len; i++)
    e.kinds[i] === "hard-break" && (n.push({
      startSegmentIndex: r,
      endSegmentIndex: i,
      consumedEndSegmentIndex: i + 1
    }), r = i + 1);
  return r < e.len && n.push({
    startSegmentIndex: r,
    endSegmentIndex: e.len,
    consumedEndSegmentIndex: e.len
  }), n;
}
function Je(e, t, n) {
  if (t.len <= 1)
    return t;
  const r = [], i = [], x = [], F = [];
  let l = -1, o = !1;
  function s(N) {
    r.push(t.texts[N]), i.push(t.isWordLike[N]), x.push("text"), F.push(t.starts[N]);
  }
  function u(N, f) {
    let C = !1;
    for (let L = N; L < f; L++)
      C = C || t.isWordLike[L];
    const p = t.starts[N], m = f < t.len ? t.starts[f] : e.length;
    r.push(e.slice(p, m)), i.push(C), x.push("text"), F.push(p);
  }
  function c(N) {
    if (!(l < 0)) {
      if (o)
        l + 1 === N ? s(l) : u(l, N);
      else
        for (let f = l; f < N; f++)
          s(f);
      l = -1, o = !1;
    }
  }
  for (let N = 0; N < t.len; N++) {
    const f = t.texts[N], C = t.kinds[N];
    if (C === "text") {
      l >= 0 && !w0(t.texts[N - 1], n) && c(N), l < 0 && (l = N), o = o || G(f);
      continue;
    }
    c(N), r.push(f), i.push(t.isWordLike[N]), x.push(C), F.push(t.starts[N]);
  }
  return c(t.len), {
    len: r.length,
    texts: r,
    isWordLike: i,
    kinds: x,
    starts: F
  };
}
function Ue(e, t, n = "normal", r = "normal") {
  const i = $0(n), x = i.mode === "pre-wrap" ? q0(e) : _0(e);
  if (x.length === 0)
    return {
      normalized: x,
      chunks: [],
      len: 0,
      texts: [],
      isWordLike: [],
      kinds: [],
      starts: []
    };
  const F = Ge(x, t, i), l = r === "keep-all" ? Je(x, F, t.breakKeepAllAfterPunctuation) : F;
  return {
    normalized: x,
    chunks: ze(l, i),
    ...l
  };
}
let $ = null;
const L0 = /* @__PURE__ */ new Map();
let _ = null;
const He = 96, Qe = new RegExp("\\p{Emoji_Presentation}", "u"), $e = /[\p{Emoji_Presentation}\p{Extended_Pictographic}\p{Regional_Indicator}\uFE0F\u20E3]/u;
let s0 = null;
const O0 = /* @__PURE__ */ new Map();
function S0() {
  if ($ !== null)
    return $;
  if (typeof OffscreenCanvas < "u")
    return $ = new OffscreenCanvas(1, 1).getContext("2d"), $;
  if (typeof document < "u")
    return $ = document.createElement("canvas").getContext("2d"), $;
  throw new Error("Text measurement requires OffscreenCanvas or a DOM canvas context.");
}
function _e(e) {
  let t = L0.get(e);
  return t || (t = /* @__PURE__ */ new Map(), L0.set(e, t)), t;
}
function J(e, t) {
  let n = t.get(e);
  return n === void 0 && (n = {
    width: S0().measureText(e).width,
    containsCJK: G(e)
  }, t.set(e, n)), n;
}
function n0() {
  if (_ !== null)
    return _;
  if (typeof navigator > "u")
    return _ = {
      lineFitEpsilon: 5e-3,
      carryCJKAfterClosingQuote: !1,
      breakKeepAllAfterPunctuation: !0,
      preferPrefixWidthsForBreakableRuns: !1,
      preferEarlySoftHyphenBreak: !1
    }, _;
  const e = navigator.userAgent, n = navigator.vendor === "Apple Computer, Inc." && e.includes("Safari/") && !e.includes("Chrome/") && !e.includes("Chromium/") && !e.includes("CriOS/") && !e.includes("FxiOS/") && !e.includes("EdgiOS/"), r = e.includes("Chrome/") || e.includes("Chromium/") || e.includes("CriOS/") || e.includes("Edg/");
  return _ = {
    lineFitEpsilon: n ? 1 / 64 : 5e-3,
    carryCJKAfterClosingQuote: r,
    breakKeepAllAfterPunctuation: !n,
    preferPrefixWidthsForBreakableRuns: n,
    preferEarlySoftHyphenBreak: n
  }, _;
}
function qe(e) {
  const t = e.match(/(\d+(?:\.\d+)?)\s*px/);
  return t ? parseFloat(t[1]) : 16;
}
function v0() {
  return s0 === null && (s0 = new Intl.Segmenter(void 0, { granularity: "grapheme" })), s0;
}
function Xe(e) {
  return Qe.test(e) || e.includes("️");
}
function Ze(e) {
  return $e.test(e);
}
function Ve(e, t) {
  let n = O0.get(e);
  if (n !== void 0)
    return n;
  const r = S0();
  r.font = e;
  const i = r.measureText("😀").width;
  if (n = 0, i > t + 0.5 && typeof document < "u" && document.body !== null) {
    const x = document.createElement("span");
    x.style.font = e, x.style.display = "inline-block", x.style.visibility = "hidden", x.style.position = "absolute", x.textContent = "😀", document.body.appendChild(x);
    const F = x.getBoundingClientRect().width;
    document.body.removeChild(x), i - F > 0.5 && (n = i - F);
  }
  return O0.set(e, n), n;
}
function Ye(e) {
  let t = 0;
  const n = v0();
  for (const r of n.segment(e))
    Xe(r.segment) && t++;
  return t;
}
function et(e, t) {
  return t.emojiCount === void 0 && (t.emojiCount = Ye(e)), t.emojiCount;
}
function H(e, t, n) {
  return n === 0 ? t.width : t.width - et(e, t) * n;
}
function tt(e, t, n, r, i) {
  if (t.breakableFitAdvances !== void 0 && t.breakableFitMode === i)
    return t.breakableFitAdvances;
  t.breakableFitMode = i;
  const x = v0(), F = [];
  for (const u of x.segment(e))
    F.push(u.segment);
  if (F.length <= 1)
    return t.breakableFitAdvances = null, t.breakableFitAdvances;
  if (i === "sum-graphemes") {
    const u = [];
    for (const c of F) {
      const N = J(c, n);
      u.push(H(c, N, r));
    }
    return t.breakableFitAdvances = u, t.breakableFitAdvances;
  }
  if (i === "pair-context" || F.length > He) {
    const u = [];
    let c = null, N = 0;
    for (const f of F) {
      const C = J(f, n), p = H(f, C, r);
      if (c === null)
        u.push(p);
      else {
        const m = c + f, L = J(m, n);
        u.push(H(m, L, r) - N);
      }
      c = f, N = p;
    }
    return t.breakableFitAdvances = u, t.breakableFitAdvances;
  }
  const l = [];
  let o = "", s = 0;
  for (const u of F) {
    o += u;
    const c = J(o, n), N = H(o, c, r);
    l.push(N - s), s = N;
  }
  return t.breakableFitAdvances = l, t.breakableFitAdvances;
}
function nt(e, t) {
  const n = S0();
  n.font = e;
  const r = _e(e), i = qe(e), x = t ? Ve(e, i) : 0;
  return { cache: r, fontSize: i, emojiCorrection: x };
}
function xt(e) {
  return e === "space" || e === "zero-width-break" || e === "soft-hyphen";
}
function T0(e) {
  return e === "space" || e === "preserved-space" || e === "tab" || e === "zero-width-break" || e === "soft-hyphen";
}
function P0(e, t, n = e.widths.length) {
  for (; t < n; ) {
    const r = e.kinds[t];
    if (!xt(r))
      break;
    t++;
  }
  return t;
}
function rt(e, t) {
  if (t <= 0)
    return 0;
  const n = e % t;
  return Math.abs(n) <= 1e-6 ? t : t - n;
}
function it(e, t, n) {
  return e.letterSpacing !== 0 && t && e.spacingGraphemeCounts[n] > 0 ? e.letterSpacing : 0;
}
function A0(e, t) {
  return t === 0 ? 0 : e + t;
}
function st(e, t) {
  return e.letterSpacing !== 0 && e.spacingGraphemeCounts[t] > 0 ? e.letterSpacing : 0;
}
function ut(e, t, n, r, i) {
  const x = t === "tab" ? i + st(e, n) : e.lineEndFitAdvances[n];
  return A0(r, x);
}
function k0(e, t, n, r) {
  const i = t === "tab" ? 0 : e.lineEndFitAdvances[n];
  return A0(r, i);
}
function m0(e, t, n, r, i) {
  const x = t === "tab" ? i : e.lineEndPaintAdvances[n];
  return A0(r, x);
}
function Ft(e, t, n) {
  return e.letterSpacing !== 0 && t ? n + e.letterSpacing : n;
}
function lt(e, t) {
  return e.letterSpacing === 0 ? t : t + e.letterSpacing;
}
function V(e, t, n) {
  let r = t;
  for (; r < e.length && e[r] < n; )
    r++;
  return r;
}
function ot(e, t, n, r, i) {
  if (e.letterSpacing === 0)
    return 0;
  if (i > 0)
    return e.spacingGraphemeCounts[r] > 0 ? e.letterSpacing : 0;
  for (let x = r - 1; x >= t; x--) {
    const F = e.kinds[x];
    if (!(F === "space" || F === "zero-width-break" || F === "hard-break")) {
      if (F === "soft-hyphen") {
        if (x === r - 1)
          return 0;
        continue;
      }
      return x === t && n > 0 || e.spacingGraphemeCounts[x] > 0 ? e.letterSpacing : 0;
    }
  }
  return 0;
}
function ct(e, t, n, r, i, x) {
  return t + ot(e, n, r, i, x);
}
function Nt(e, t, n) {
  const { widths: r, kinds: i, breakableFitAdvances: x, breakablePreferredBreaks: F } = e;
  if (r.length === 0)
    return 0;
  const o = n0().lineFitEpsilon, s = t + o;
  let u = 0, c = 0, N = !1, f = 0, C = 0, p = 0, m = 0, L = -1, b = 0;
  function W() {
    L = -1, b = 0;
  }
  function y(M = p, d = m, g = c) {
    u++, n?.(g, f, C, M, d), c = 0, N = !1, W();
  }
  function k(M, d) {
    N = !0, f = M, C = 0, p = M + 1, m = 0, c = d;
  }
  function a(M, d, g) {
    N = !0, f = M, C = d, p = M, m = d + 1, c = g;
  }
  function E(M, d) {
    if (!N) {
      k(M, d);
      return;
    }
    c += d, p = M + 1, m = 0;
  }
  function j(M, d) {
    const g = x[M], R = F[M] ?? null;
    let w = R === null ? -1 : V(R, 0, d + 1), A = -1, h = 0, B = d;
    for (; B < g.length; ) {
      const S = g[B];
      if (!N)
        a(M, B, S);
      else if (c + S > s) {
        if (R !== null && A > d) {
          y(M, A, h), B = A, w = V(R, w, B + 1), A = -1, h = 0;
          continue;
        }
        y(), a(M, B, S);
      } else
        c += S, p = M, m = B + 1;
      const O = B + 1;
      R !== null && R[w] === O && (A = O, h = c, w++), B++;
    }
    N && p === M && m === g.length && (p = M + 1, m = 0);
  }
  let D = 0;
  for (; D < r.length && !(!N && (D = P0(e, D), D >= r.length)); ) {
    const M = r[D], d = i[D], g = T0(d);
    if (!N) {
      M > s && x[D] !== null ? j(D, 0) : k(D, M), g && (L = D + 1, b = c - M), D++;
      continue;
    }
    if (c + M > s) {
      if (g) {
        E(D, M), y(D + 1, 0, c - M), D++;
        continue;
      }
      if (L >= 0) {
        if (p > L || p === L && m > 0) {
          y();
          continue;
        }
        y(L, 0, b);
        continue;
      }
      if (M > s && x[D] !== null) {
        y(), j(D, 0), D++;
        continue;
      }
      y();
      continue;
    }
    E(D, M), g && (L = D + 1, b = c - M), D++;
  }
  return N && y(), u;
}
function at(e, t, n) {
  if (e.simpleLineWalkFastPath)
    return Nt(e, t, n);
  const { widths: r, kinds: i, breakableFitAdvances: x, breakablePreferredBreaks: F, discretionaryHyphenWidth: l, chunks: o } = e;
  if (r.length === 0 || o.length === 0)
    return 0;
  const s = n0(), u = s.lineFitEpsilon, c = t + u;
  let N = 0, f = 0, C = !1, p = 0, m = 0, L = 0, b = 0, W = -1, y = 0, k = 0, a = null;
  function E() {
    W = -1, y = 0, k = 0, a = null;
  }
  function j() {
    return a === "soft-hyphen" && W === L && b === 0 ? k : f;
  }
  function D(h = L, B = b, S) {
    N++, n !== void 0 && n(ct(e, S ?? j(), p, m, h, B), p, m, h, B), f = 0, C = !1, E();
  }
  function M(h, B) {
    C = !0, p = h, m = 0, L = h + 1, b = 0, f = B;
  }
  function d(h, B, S) {
    C = !0, p = h, m = B, L = h, b = B + 1, f = S;
  }
  function g(h, B) {
    if (!C) {
      M(h, B);
      return;
    }
    f += B, L = h + 1, b = 0;
  }
  function R(h, B, S, O, P, v) {
    if (!B)
      return;
    const I = k0(e, h, S, P), T = m0(e, h, S, P, O);
    W = S + 1, y = f - v + I, k = f - v + T, a = h;
  }
  function w(h, B) {
    const S = x[h], O = F[h] ?? null;
    let P = O === null ? -1 : V(O, 0, B + 1), v = -1, I = 0, T = B;
    for (; T < S.length; ) {
      const z = S[T];
      if (!C)
        d(h, T, z);
      else {
        const r0 = Ft(e, !0, z), X = f + r0;
        if (lt(e, X) > c) {
          if (O !== null && v > B) {
            D(h, v, I), T = v, P = V(O, P, T + 1), v = -1, I = 0;
            continue;
          }
          D(), d(h, T, z);
        } else
          f = X, L = h, b = T + 1;
      }
      const x0 = T + 1;
      O !== null && O[P] === x0 && (v = x0, I = f, P++), T++;
    }
    C && L === h && b === S.length && (L = h + 1, b = 0);
  }
  function A(h) {
    N++, n?.(0, h.startSegmentIndex, 0, h.consumedEndSegmentIndex, 0), E();
  }
  for (let h = 0; h < o.length; h++) {
    const B = o[h];
    if (B.startSegmentIndex === B.endSegmentIndex) {
      A(B);
      continue;
    }
    C = !1, f = 0, p = B.startSegmentIndex, m = 0, L = B.startSegmentIndex, b = 0, E();
    let S = B.startSegmentIndex;
    for (; S < B.endSegmentIndex && !(!C && (S = P0(e, S, B.endSegmentIndex), S >= B.endSegmentIndex)); ) {
      const O = i[S], P = T0(O), v = it(e, C, S), I = O === "tab" ? rt(f + v, e.tabStopAdvance) : r[S], T = v + I, z = ut(e, O, S, v, I);
      if (O === "soft-hyphen") {
        C && (L = S + 1, b = 0, W = S + 1, y = f + l, k = f + l, a = O), S++;
        continue;
      }
      if (!C) {
        z > c && x[S] !== null ? w(S, 0) : M(S, I), R(O, P, S, I, v, T), S++;
        continue;
      }
      if (f + z > c) {
        const r0 = f + k0(e, O, S, v), X = f + m0(e, O, S, v, I);
        if (a === "soft-hyphen" && s.preferEarlySoftHyphenBreak && y <= c) {
          D(W, 0, k);
          continue;
        }
        if (P && r0 <= c) {
          g(S, T), D(S + 1, 0, X), S++;
          continue;
        }
        if (W >= 0 && y <= c) {
          if (L > W || L === W && b > 0) {
            D();
            continue;
          }
          const h0 = W;
          D(h0, 0, k), S = h0;
          continue;
        }
        if (z > c && x[S] !== null) {
          D(), w(S, 0), S++;
          continue;
        }
        D();
        continue;
      }
      g(S, T), R(O, P, S, I, v, T), S++;
    }
    if (C) {
      const O = W === B.consumedEndSegmentIndex ? k : f;
      D(B.consumedEndSegmentIndex, 0, O);
    }
  }
  return N;
}
let u0 = null;
function E0() {
  return u0 === null && (u0 = new Intl.Segmenter(void 0, { granularity: "grapheme" })), u0;
}
function ft(e) {
  return {
    widths: [],
    lineEndFitAdvances: [],
    lineEndPaintAdvances: [],
    kinds: [],
    simpleLineWalkFastPath: !0,
    segLevels: null,
    breakableFitAdvances: [],
    breakablePreferredBreaks: [],
    letterSpacing: 0,
    spacingGraphemeCounts: [],
    discretionaryHyphenWidth: 0,
    tabStopAdvance: 0,
    chunks: [],
    segments: []
  };
}
function St(e, t) {
  const n = [];
  let r = [], i = 0, x = !1, F = !1, l = !1;
  function o() {
    r.length !== 0 && (n.push({
      text: r.length === 1 ? r[0] : r.join(""),
      start: i
    }), r = [], x = !1, F = !1, l = !1);
  }
  function s(c, N, f) {
    r = [c], i = N, x = f, F = F0(c), l = Y.has(c);
  }
  function u(c, N) {
    r.push(c), x = x || N;
    const f = F0(c);
    c.length === 1 && Q.has(c) ? F = F || f : F = f, l = !1;
  }
  for (const c of E0().segment(e)) {
    const N = c.segment, f = G(N);
    if (r.length === 0) {
      s(N, c.index, f);
      continue;
    }
    if (l || N0.has(N) || Q.has(N) || t.carryCJKAfterClosingQuote && f && F) {
      u(N, f);
      continue;
    }
    if (!x && !f) {
      u(N, f);
      continue;
    }
    o(), s(N, c.index, f);
  }
  return o(), n;
}
function At(e, t, n) {
  if (t.length <= 1)
    return t;
  const r = [];
  let i = -1, x = !1;
  function F(o, s) {
    const u = t[o].start, c = s < t.length ? t[s].start : e.length;
    r.push({
      text: e.slice(u, c),
      start: u
    });
  }
  function l(o) {
    if (!(i < 0)) {
      if (x)
        i + 1 === o ? r.push(t[i]) : F(i, o);
      else
        for (let s = i; s < o; s++)
          r.push(t[s]);
      i = -1, x = !1;
    }
  }
  for (let o = 0; o < t.length; o++) {
    const s = t[o];
    i >= 0 && !w0(t[o - 1].text, n) && l(o), i < 0 && (i = o), x = x || G(s.text);
  }
  return l(t.length), r;
}
function b0(e, t) {
  if (t === "zero-width-break" || t === "soft-hyphen" || t === "hard-break")
    return 0;
  if (t === "tab")
    return 1;
  let n = 0;
  const r = E0();
  for (const i of r.segment(e))
    n++;
  return n;
}
function Et(e) {
  return e === "-" || e === "֊" || e === "‐" || e === "‒" || e === "–" || e === "—";
}
function ht(e) {
  if (!/[-\u058A\u2010\u2012\u2013\u2014]/u.test(e))
    return null;
  const t = [];
  let n = 0;
  for (const r of E0().segment(e))
    n++, Et(r.segment) && t.push(n);
  return t.length === 0 ? null : t;
}
function Bt(e, t, n) {
  return t > 1 ? e + (t - 1) * n : e;
}
function Ct(e, t, n, r, i) {
  const x = n0(), { cache: F, emojiCorrection: l } = nt(t, Ze(e.normalized)), o = H("-", J("-", F), l) + (i === 0 ? 0 : i * 2), u = H(" ", J(" ", F), l) * 8, c = i !== 0;
  if (e.len === 0)
    return ft();
  const N = [], f = [], C = [], p = [];
  let m = e.chunks.length <= 1 && !c;
  const L = n ? [] : null, b = [], W = [], y = [], k = n ? [] : null, a = Array.from({ length: e.len });
  function E(d, g, R, w, A, h, B, S, O) {
    A !== "text" && A !== "space" && A !== "zero-width-break" && (m = !1), N.push(g), f.push(R), C.push(w), p.push(A), L?.push(h), b.push(B), W.push(S), c && y.push(O), k !== null && k.push(d);
  }
  function j(d, g, R, w, A) {
    const h = J(d, F), B = c ? b0(d, g) : 0, S = Bt(H(d, h, l), B, i), O = g === "space" || g === "preserved-space" || g === "zero-width-break" ? 0 : S, P = O === 0 ? 0 : O + (B > 0 ? i : 0), v = g === "space" || g === "zero-width-break" ? 0 : S;
    if (A && w && d.length > 1) {
      let I = "sum-graphemes";
      i !== 0 ? I = "segment-prefixes" : Z(d) ? I = "pair-context" : x.preferPrefixWidthsForBreakableRuns && (I = "segment-prefixes");
      const T = tt(d, h, F, l, I), z = T === null || r === "keep-all" ? null : ht(d);
      E(d, S, P, v, g, R, T, z, B);
      return;
    }
    E(d, S, P, v, g, R, null, null, B);
  }
  for (let d = 0; d < e.len; d++) {
    a[d] = N.length;
    const g = e.texts[d], R = e.isWordLike[d], w = e.kinds[d], A = e.starts[d];
    if (w === "soft-hyphen") {
      E(g, 0, o, o, w, A, null, null, 0);
      continue;
    }
    if (w === "hard-break") {
      E(g, 0, 0, 0, w, A, null, null, 0);
      continue;
    }
    if (w === "tab") {
      E(g, 0, 0, 0, w, A, null, null, c ? b0(g, w) : 0);
      continue;
    }
    const h = J(g, F);
    if (w === "text" && h.containsCJK) {
      const B = St(g, x), S = r === "keep-all" ? At(g, B, x.breakKeepAllAfterPunctuation) : B;
      for (let O = 0; O < S.length; O++) {
        const P = S[O];
        j(P.text, "text", A + P.start, R, r === "keep-all" || !G(P.text));
      }
      continue;
    }
    j(g, w, A, R, !0);
  }
  const D = dt(e.chunks, a, N.length), M = L === null ? null : U0(e.normalized, L);
  return k !== null ? {
    widths: N,
    lineEndFitAdvances: f,
    lineEndPaintAdvances: C,
    kinds: p,
    simpleLineWalkFastPath: m,
    segLevels: M,
    breakableFitAdvances: b,
    breakablePreferredBreaks: W,
    letterSpacing: i,
    spacingGraphemeCounts: y,
    discretionaryHyphenWidth: o,
    tabStopAdvance: u,
    chunks: D,
    segments: k
  } : {
    widths: N,
    lineEndFitAdvances: f,
    lineEndPaintAdvances: C,
    kinds: p,
    simpleLineWalkFastPath: m,
    segLevels: M,
    breakableFitAdvances: b,
    breakablePreferredBreaks: W,
    letterSpacing: i,
    spacingGraphemeCounts: y,
    discretionaryHyphenWidth: o,
    tabStopAdvance: u,
    chunks: D
  };
}
function dt(e, t, n) {
  const r = [];
  for (let i = 0; i < e.length; i++) {
    const x = e[i], F = x.startSegmentIndex < t.length ? t[x.startSegmentIndex] : n, l = x.endSegmentIndex < t.length ? t[x.endSegmentIndex] : n, o = x.consumedEndSegmentIndex < t.length ? t[x.consumedEndSegmentIndex] : n;
    r.push({
      startSegmentIndex: F,
      endSegmentIndex: l,
      consumedEndSegmentIndex: o
    });
  }
  return r;
}
function Mt(e, t, n, r) {
  const i = r?.wordBreak ?? "normal", x = r?.letterSpacing ?? 0, F = Ue(e, n0(), r?.whiteSpace, i);
  return Ct(F, t, n, i, x);
}
function Dt(e, t, n) {
  return Mt(e, t, !0, n);
}
function pt(e) {
  let t = 0;
  return at(e, Number.POSITIVE_INFINITY, (n) => {
    n > t && (t = n);
  }), t;
}
const W0 = typeof Intl < "u" && typeof Intl.Segmenter == "function" ? new Intl.Segmenter(void 0, { granularity: "grapheme" }) : null;
function I0(e) {
  if (W0) {
    const t = [];
    for (const { segment: n } of W0.segment(e))
      t.push(n);
    return t;
  }
  return Array.from(e);
}
function o0(e, t, n, r) {
  const i = e.length;
  if (t >= i)
    return e.join("");
  if (t <= 0)
    return r;
  switch (n) {
    case "start":
      return r + e.slice(i - t).join("");
    case "center": {
      const x = Math.ceil(t / 2), F = t - x;
      return e.slice(0, x).join("") + r + (F > 0 ? e.slice(i - F).join("") : "");
    }
    default:
      return e.slice(0, t).join("") + r;
  }
}
function gt(e, t, n, r, i) {
  if (e === "" || t <= 0)
    return { text: e, isTruncated: !1 };
  if (i(e) <= t)
    return { text: e, isTruncated: !1 };
  const x = I0(e);
  let F = 0, l = x.length - 1, o = 0;
  for (; F <= l; ) {
    const s = Math.floor((F + l) / 2);
    i(o0(x, s, n, r)) <= t ? (o = s, F = s + 1) : l = s - 1;
  }
  return { text: o0(x, o, n, r), isTruncated: !0 };
}
function Lt(e, t, n, r) {
  if (t === void 0)
    return { text: e, isTruncated: !1 };
  const i = I0(e);
  return i.length <= t ? { text: e, isTruncated: !1 } : {
    text: o0(i, Math.max(0, t), n, r),
    isTruncated: !0
  };
}
function Ot(e) {
  const t = getComputedStyle(e), n = t.font && t.font.trim() !== "" ? t.font : `${t.fontStyle} ${t.fontWeight} ${t.fontSize} ${t.fontFamily}`, r = Number.parseFloat(t.letterSpacing);
  return { font: n, letterSpacing: Number.isFinite(r) ? r : 0 };
}
function mt(e, t) {
  const { ref: n, position: r = "end", ellipsis: i = "…", truncateMode: x = "pretext", maxChars: F } = t, [l, o] = B0(0), [s, u] = B0("");
  return j0(() => {
    if (x !== "pretext")
      return;
    const c = n.current;
    if (!c)
      return;
    const N = () => {
      const C = getComputedStyle(c), p = Number.parseFloat(C.paddingLeft) + Number.parseFloat(C.paddingRight);
      o(Math.max(0, c.clientWidth - p));
      const { font: m, letterSpacing: L } = Ot(c);
      u(`${m}|${L}`);
    };
    N();
    const f = new ResizeObserver(N);
    return f.observe(c), () => f.disconnect();
  }, [n, x]), K0(() => {
    if (x === "maxChars")
      return Lt(e, F, r, i);
    if (l <= 0)
      return { text: e, isTruncated: !1 };
    const c = s.lastIndexOf("|"), N = c === -1 ? s : s.slice(0, c), f = c === -1 ? 0 : Number(s.slice(c + 1)) || 0;
    return gt(e, l, r, i, (p) => pt(Dt(p, N, { letterSpacing: f })));
  }, [e, x, F, r, i, l, s]);
}
export {
  o0 as buildTruncated,
  gt as computeFitTruncation,
  Lt as computeMaxCharsTruncation,
  mt as useTruncate
};
